import { LocaleTime } from '@mi-front/ui';
import moment from 'moment-timezone';
import React from 'react';
import { useTimezone } from '@app/core/hooks/useTimezone';

interface Props extends React.ComponentProps<typeof LocaleTime> {
  tz?: string;
  showSeconds?: boolean;
  hour12?: boolean;
}

export const LTime = (p: Props) => {
  const { value, tz: passedTz, showSeconds = false, hour12 = false, ...rest } = p;
  const contextTz = useTimezone();
  const tz = passedTz || contextTz;

  return (
    <span title={moment(value).tz(tz).format('LLLL (Z)')}>
      <LocaleTime
        timeZone={tz}
        value={value}
        second={showSeconds ? '2-digit' : undefined}
        hour12={hour12}
        {...rest}
      />
    </span>
  );
};
